<template>
  <AForm
    id="forgotPasswordForm"
    :state
    :localized="false"
    :handler
    :close-modal-after-submit="false"
    :submit-label="$t('components.aForgotPasswordForm.submit')"
  >
    <UFormGroup
      size="lg"
      :label="$t('components.aLoginForm.emailForgotPasswordLabel')"
      name="username"
    >
      <UInput
        v-model="state.username"
        type="email"
        autocomplete="email"
        placeholder="email@example.com"
        trailing-icon="fluent:mail-32-regular"
      />
    </UFormGroup>
  </AForm>
</template>

<script setup lang="ts">
const { $swal } = useNuxtApp()
const { t } = useI18n()

const state = ref<{
  username?: string
}>({})

async function handler({ data }: any) {
  await $fetch('/api/users/forgot_password', {
    body: { email: data.username },
    method: 'POST',
  })

  $swal.success({
    showCancelButton: false,
    text: t('components.aForgotPasswordForm.swal.text'),
    title: t('components.aForgotPasswordForm.swal.title'),
  })
}
</script>
